export function PastMeals() {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        width: "100%",
        marginTop: "8px",
      }}
    >
      <div style={{ width: "100%" }}>
        <iframe
          title="Past Meals"
          className="airtable-embed"
          src="https://airtable.com/embed/appRyDpw6P4HZIdqT/shri1HxVv90Un5c4i"
          width="100%"
          height="800"
          style={{ background: "transparent" }}
        ></iframe>
      </div>
    </div>
  );
}
